import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SectionBarComponent } from 'src/app/shared/sectionbar/sectionbar.component';
import { GridDataSource, LoaderService, NotificationService, TYPEMODULE } from 'src/app/shared/session';
import { AccessService } from '../../Accesses/shared/access.service';
import { NivelAcceso } from '../../nivelAcceso/shared/nivel-acceso.model';
import { Aplicacion } from '../../Aplicaciones/shared/aplicacion.model';
import { NivelAccesoService } from '../../nivelAcceso/shared/nivel-acceso.service';
import { AplicacionService } from '../../Aplicaciones/shared/aplicacion.service';
import { AccesoSubmoduloService } from '../shared/acceso-submodulo.service';
import { Entidad } from '../../entidad/shared/entidad.model';
import { EntidadService } from '../../entidad/shared/entidad.service';
import { SelectOption } from 'src/app/shared/common/select-option';
import { ReporteService } from '../shared/reporte.service';
import { AccesoReporteService } from '../shared/acceso-reporte.service';

@Component({
  selector: 'app-acceso-submodulo-list',
  templateUrl: './acceso-submodulo-list.component.html',
})
export class AccesoSubmoduloListComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() typeModule: TYPEMODULE;
  @Input() titlePage: string;
  @Input() data: any;
  @ViewChild(SectionBarComponent) sectionBarComponent: SectionBarComponent;

  displayedColumns: string[];
  dataSource: GridDataSource;
  msgErrorGet: string;
  showMessageGridEmpty: boolean = false;
  nivelesAcceso: NivelAcceso[];
  idNivelAcceso: number;
  aplicaciones: Aplicacion[];
  idAplicacion: number;
  entidades: Entidad[] = [];
  idEntidad: number;
  tipos: SelectOption[];
  idTipo: number;
  dataSourceReporte: GridDataSource;
  displayedColumnsReporte: string[];

  constructor(
    private loaderService: LoaderService,
    private accessService: AccessService,
    private notificationService: NotificationService,
    private nivelAccesoService: NivelAccesoService,
    private aplicacionService: AplicacionService,
    private accesoSubmoduloService: AccesoSubmoduloService,
    private entidadService: EntidadService,
    private reporteService: ReporteService,
    private accesoReporteService: AccesoReporteService,
  ) { }

  ngOnInit() {
    this.msgErrorGet = 'Error al listar las Accesos';
    this.displayedColumns = ['indCheck', 'AccessID', 'Name', 'Path', 'Description', 'Icono', 'Status'];
    this.displayedColumnsReporte = ['indCheck', 'codigo', 'nombre'];
    this.tipos = [new SelectOption('Accesos', 1), new SelectOption('Reportes', 2)];
    this.idTipo = this.tipos[0].valor;
    this.initData();
  }

  async initData() {
    this.loaderService.show();
    this.aplicaciones = await this.aplicacionService.listarApplication().toPromise();
    this.idAplicacion = this.aplicaciones[0].ID;
    this.nivelesAcceso = await this.nivelAccesoService.listarNivelAcceso().toPromise();
    this.idNivelAcceso = this.nivelesAcceso[0].id;
    await this.listarEntidad();
    this.loaderService.hide();
  }

  async listarEntidad() {
    this.entidades = await this.entidadService.listByNivelAcceso(this.idNivelAcceso).toPromise();
    if (this.entidades.length > 0) {
      this.idEntidad = this.entidades[0].id;
      this.listar();
    } else {
      this.notificationService.warning("No hay entidades registradas");
      this.dataSource = new GridDataSource([]);
      this.dataSourceReporte = new GridDataSource([]);
      this.showHideMessageGridEmpty(0);
      this.idEntidad = null;
    }
  }

  searchEmit() {
    this.listar();
  }

  changeEvent(event) {
    this.onChangeEvent.emit(event);
  }

  onChangeAplicacion() {
    this.listarAccesoSubmodulo();
  }

  onChangeNivelAcceso() {
    this.listarEntidad();
  }

  onChangeEntidad() {
    this.listar();
  }

  onChangeTipo() {
    this.listar();
  }

  listarAccesoSubmodulo() {
    if (this.idAplicacion == null || this.idNivelAcceso == null || this.idEntidad == null)
      return;
    this.loaderService.show();
    this.accessService.listarAccesoSubmodulo(this.sectionBarComponent.filtro, this.idAplicacion, this.idNivelAcceso, this.idEntidad, this.data.rol.ID)
      .subscribe(res => {
        this.dataSource = new GridDataSource(res);
        this.showHideMessageGridEmpty(Number(res.length));
      },
        error => {
          this.notificationService.error(this.msgErrorGet);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

  onChangeVinculacion(row: any) {
    this.guardarAccesoSubmodulo(row.ID);
  }

  guardarAccesoSubmodulo(idAccess: number): void {
    this.loaderService.show();
    this.accesoSubmoduloService.guardarAccesoSubmodulo(this.idAplicacion, this.idNivelAcceso, this.idEntidad, this.data.rol.ID, idAccess)
      .subscribe(res => {
        this.notificationService.successful("Se grabo satisfactoriamente");
      },
        error => {
          this.notificationService.error("Error al asignar acceso");
          this.listar();
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

  showHideMessageGridEmpty(rows: number) {
    this.showMessageGridEmpty = false;
    if (rows <= 0) this.showMessageGridEmpty = true;
  }

  listarAccesoReporte() {
    if (this.idNivelAcceso == null || this.idEntidad == null)
      return;
    this.loaderService.show();
    this.reporteService.listarAccesoReporte(this.sectionBarComponent.filtro, this.idNivelAcceso, this.idEntidad, this.data.rol.ID)
      .subscribe(res => {
        this.dataSourceReporte = new GridDataSource(res);
        this.showHideMessageGridEmpty(Number(res.length));
      },
        error => {
          this.notificationService.error(this.msgErrorGet);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

  listar() {
    if (this.idTipo == 2) {
      this.listarAccesoReporte();
    } else if (this.idTipo == 1) {
      this.listarAccesoSubmodulo();
    }
  }

  onChangeVinculacionReporte(row: any) {
    this.guardarAccesoReporte(row.id);
  }

  guardarAccesoReporte(idReporte: number): void {
    this.loaderService.show();
    this.accesoReporteService.guardarAccesoReporte(this.idNivelAcceso, this.idEntidad, this.data.rol.ID, idReporte)
      .subscribe(res => {
        this.notificationService.successful("Se grabo satisfactoriamente");
      },
        error => {
          this.notificationService.error("Error al asignar acceso");
          this.listar();
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }
}